
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
components: {
Flexbox,
FlexboxItem
},
methods: {

JumpVideo: function (IDCodes) {
this.$router.replace({
path: "/Index/Course",
name: "/Index/Course",
params: {
IDCode: IDCodes,
level1: "推荐",
}
})
},
},
data() {
return {
RecommendList: [],
}
},
created() {
this.$tyh.GetRecommend("4", this.$route.params.IDCode)
.then((data) => {
if(data.data.Data.length == 0){
return ;
}
var show_data = new Array();
for (var t in data.data.Data) {
var name = data.data.Data[t].Name;
if (name.length > 35) {
name = name.substr(0, 35) + "...";
}
var content = data.data.Data[t].Content;
if (content.length > 35) {
content = content.substr(0, 35) + "...";
}
var level = "";
switch (data.data.Data[t].Level) {
case 1:
level = "初级";
break;
case 2:
level = "中级";
break;
case 3:
level = "高级";
break;
}
var showdatas = {
IDCode: data.data.Data[t].IDCode,
Logo: this.$tyh.APIURL + '/' + data.data.Data[t].Logo,
Content: content,
level:level,
Name: name,
}
show_data.push(showdatas)
}
this.RecommendList = show_data;
});
},
}



// WEBPACK FOOTER //
// ./src/views/Index/Course/Recommend.vue